import { Controller } from "@hotwired/stimulus"

// Toggles the day-of-week and time-of-day inputs in the board automation
// schedule editor based on the selected frequency:
//   hourly → neither, daily → time only, weekly → days + time.
export default class extends Controller {
  static targets = ["frequency", "days", "time"]

  connect() {
    this.frequencyChanged()
  }

  frequencyChanged() {
    const frequency = this.frequencyTarget.value
    this.toggle(this.hasDaysTarget && this.daysTarget, frequency === "weekly")
    this.toggle(this.hasTimeTarget && this.timeTarget, frequency !== "hourly")
  }

  toggle(element, show) {
    if (!element) return
    element.classList.toggle("d-none", !show)
  }
}
